import PropTypes from 'prop-types';

import { TComma } from '../../base/utils';
import styles from './Uniter.module.css';

const Uniter = ({ children, unit, className }) => (
  <div className={`uniter-container ${className || ''}`}>
    {children === undefined ? '' : TComma(children)}
    {/* {} */}
    {unit ? <small className={styles.UniterUnit}>{unit}</small> : null}
  </div>
);

Uniter.propTypes = {
  children: PropTypes.any,
  unit: PropTypes.string,
  className: PropTypes.string
};

export default Uniter;
